import React, { useCallback } from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../../hooks/useTranslation';

import { CountdownCircleTimer } from 'react-countdown-circle-timer';

// import { FiArrowLeftCircle, FiCheckCircle } from 'react-icons/fi';

import { config } from '../../../config';

import {
  Container,
  Content,
  AnimationContainer,
  Title,
  ColInput,
} from './styles';
import { routesEndpoints } from '../../../routes/endpoint';

const SignUpStep05: React.FC = () => {
  const { onTranslation: t } = useTranslation();
  const history = useHistory();

  const handleFinish = useCallback(async () => {
    try {
      history.push(routesEndpoints.HOME);
    } catch (err) {
      //konsole.log('error:', err);
    }
  }, [history]);

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={config.logo} alt="ConectoVarejo" />

          <form>
            <Title>
              <span>{t('main.modal_signup.signupstep05.title_01')}</span>
            </Title>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            {/* <ColInput>
              <p>
                <b>{`${first_name} ${last_name}`}</b>,{' '}
                {t('main.modal_signup.signupstep04.title_02')}
              </p>
            </ColInput> */}

            <ColInput>
              <CountdownCircleTimer
                isPlaying
                duration={10}
                colors={[
                  ['#c10101', 0.33],
                  ['#e6ea0f', 0.33],
                  ['#FF9000', 0.33],
                ]}
                onComplete={() => {
                  handleFinish();
                  return [false, 0]; // repeat animation in 1.5 seconds
                }}
              >
                {({ remainingTime }) => remainingTime}
              </CountdownCircleTimer>
            </ColInput>
          </form>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignUpStep05;
